/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Join_AlreadyInputs */

const en_us2_clubs_join_already = /** @type {(inputs: Clubs_Join_AlreadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You're already in this club.`)
};

const pt_br2_clubs_join_already = /** @type {(inputs: Clubs_Join_AlreadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você já está neste clube.`)
};

const es_419_clubs_join_already = /** @type {(inputs: Clubs_Join_AlreadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya estás en este club.`)
};

const pt_pt2_clubs_join_already = /** @type {(inputs: Clubs_Join_AlreadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já estás neste clube.`)
};

const fr_fr2_clubs_join_already = /** @type {(inputs: Clubs_Join_AlreadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu es déjà dans ce club.`)
};

const de_de2_clubs_join_already = /** @type {(inputs: Clubs_Join_AlreadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du bist schon in diesem Club.`)
};

const it_it2_clubs_join_already = /** @type {(inputs: Clubs_Join_AlreadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sei già in questo club.`)
};

/**
* | output |
* | --- |
* | "You're already in this club." |
*
* @param {Clubs_Join_AlreadyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_join_already = /** @type {((inputs?: Clubs_Join_AlreadyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Join_AlreadyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_join_already(inputs)
	if (locale === "es-419") return es_419_clubs_join_already(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_join_already(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_join_already(inputs)
	if (locale === "de-DE") return de_de2_clubs_join_already(inputs)
	if (locale === "it-IT") return it_it2_clubs_join_already(inputs)
	return en_us2_clubs_join_already(inputs)
});
export { clubs_join_already as "clubs.join_already" }